import { Formik, Form, Field } from 'formik';
import React from 'react';
import PlainButton from '../../../components/buttons/PlainButton';

function ReasonModal({ closeModal, reason }) {
    return (
        <Formik
            initialValues={{ description: '' }}
        >
            {({ isSubmitting }) => (
                <Form>
                    <div className="row mb-5">
                        <div className="col-lg-12 col-12 mt-3">
                            <Field
                                as="textarea"
                                name="description"
                                className="form-control mb-2 mt-3"
                                autoComplete="off"
                                placeholder="Details of Programme/Training"
                                style={{ height: "150px", resize: "none" }} // Prevent resizing with cursor
                                value={reason}
                            />
                        </div>
                    </div>
                    <div className="d-flex justify-content-end">
                        <PlainButton isLoading={isSubmitting} onClick={closeModal}>
                            Done
                        </PlainButton>
                    </div>
                </Form>
            )}
        </Formik>
    );
}

export default ReasonModal;
